import { useState, useContext, createContext, FC, ReactNode } from 'react';
import { Backdrop } from '@mui/material';
import { BeatLoader } from 'react-spinners';

type LoadingContext = {
  loading: boolean;
  setLoading: (loading: boolean) => void;
};

type LoadingProps = {
  children: ReactNode;
};

const LoadingContext = createContext<LoadingContext>({
  loading: false,
  setLoading: () => null
});

/**
 * @return useContext use context loading
 */
export function useLoading(): LoadingContext {
  return useContext(LoadingContext);
}
/**
 * @return LoadingProvider provider value loading
 */
export const LoadingProvider: FC<LoadingProps> = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const value = { loading, setLoading };
  return (
    <LoadingContext.Provider value={value}>
      {loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: 9999999
          }}
          open>
          <BeatLoader color={'#fff'} />
        </Backdrop>
      )}
      {children}
    </LoadingContext.Provider>
  );
};
